import { SERVICE_ACCOUNT_EXPORT_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { useCallback, useEffect, useState } from 'react';
import { httpGet } from '../../../../components/utils';
import { ServiceAccountExportOptions } from '../ServiceAccountsTypes';

export interface ExportFileStatus {
    exportReportStatus: ServiceAccountExportOptions;
    refreshExportReportStatus: () => Promise<void>;
}

export const useExportFileStatus = (): ExportFileStatus => {
    const [exportReportStatus, setExportReportStatus] = useState(SERVICE_ACCOUNT_EXPORT_OPTIONS);

    const getStatus = useCallback(async () => {
        try {
            const response = await httpGet(`/ServiceAccountsV2/exportFilesStatus`);
            if (response && response.data) {
                const serviceAccountsExports = Object.assign({}, SERVICE_ACCOUNT_EXPORT_OPTIONS);
                const exportsData = response.data as {};
                Object.keys(exportsData).forEach((key) => {
                    serviceAccountsExports[key] = { ...serviceAccountsExports[key], ...exportsData[key] };
                });
                setExportReportStatus(serviceAccountsExports);
            }
        } catch (err: any) {
            console.error('There was a problem getting the service accounts export pathes.', err.toString());
        }
    }, []);

    useEffect(() => {
        getStatus();
    }, [getStatus]);

    return { exportReportStatus, refreshExportReportStatus: getStatus };
};
